if (document.readyState !== 'loading') {
    handleQuickSearch();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        handleQuickSearch();
    });
}

function handleQuickSearch() {
    const quickSearchElements = document.querySelectorAll('.quicksearch');

    quickSearchElements.forEach(function(quickSearch) {
        const searchWrapper = quickSearch.querySelector('.cmp-search');
        const searchInput = quickSearch.querySelector('.cmp-search__input');
        const wrapperId = searchWrapper.getAttribute('id');

        if (searchInput) {
            searchInput.setAttribute('placeholder', "Suchbegriff");
            searchInput.setAttribute('id', wrapperId + '-input');
        }

        const searchLabel = document.createElement('label');
        searchLabel.classList.add('cmp-search__label');
        searchLabel.setAttribute('for', wrapperId + '-input');
        searchLabel.innerText = "Suche";
        searchWrapper.insertBefore(searchLabel, searchWrapper.firstChild);
    });
}
